var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "sendcode_comp" } }, [
    _vm.styleType == "button"
      ? _c(
          "div",
          { staticClass: "fc-pointer" },
          [
            _vm.startTimeDown
              ? _c("el-button", [
                  _vm._v(_vm._s(_vm.downnum) + "s" + _vm._s(_vm.$t("m.resend")))
                ])
              : _vm.isSendIng
              ? _c("el-button", { attrs: { type: "primary" } }, [
                  _c("i", { staticClass: "el-icon-loading" })
                ])
              : _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.getcode()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("m.get_vercode")))]
                )
          ],
          1
        )
      : _c("div", { staticClass: "fc-pointer" }, [
          _vm.startTimeDown
            ? _c("span", [
                _vm._v(_vm._s(_vm.downnum) + "s" + _vm._s(_vm.$t("m.resend")))
              ])
            : _vm.isSendIng
            ? _c("span", [_c("i", { staticClass: "el-icon-loading" })])
            : _c(
                "span",
                {
                  on: {
                    click: function($event) {
                      return _vm.getcode()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("m.get_vercode")))]
              )
        ]),
    _vm._v(" "),
    _vm.showRecaptcha
      ? _c("div", {
          staticClass: "recaptcha_box",
          attrs: { id: "html_element" }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00caf9f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00caf9f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sendcode.vue
// module id = null
// module chunks = 